<script lang="ts" module>
  import BaseBtn from '@/ui/base/BaseBtn.svelte';
  import Icon from '@/ui/base/icon/Icon.svelte';
  import LoadingArea from '@/ui/base/LoadingArea.svelte';
  import ImpactTPI from '@/ui/components/assistant/Performance/AICard/cmps/ImpactTPI.svelte';
  import PaginationNext from '@/ui/elements/pagination/PaginationNext.svelte';

  import AiSuggestionHidden from './AiSuggestionHidden.svelte';

  namespace AISuggestions {
    export interface Props {
      count: number;
      loading?: boolean;
      onRemoveSuggestion: (index: number) => void;
      onSelectSuggestion: (index: number) => void;
      selected: number;
      text?: string;
      tpi?: number;
      hidden?: boolean;
      onUnhideSuggestion: () => void;
    }
  }
</script>

<script lang="ts">
  let props: AISuggestions.Props = $props();
  let hasTPI = $derived(typeof props.tpi !== 'undefined');
</script>

<div class="flex flex-col gap-2 rounded-sm bg-sec p-1">
  {#if props.loading}
    <LoadingArea />
  {:else}
    <div class={`flex flex-row ${hasTPI ? 'justify-between' : 'justify-end'}`}>
      {#if hasTPI}
        <ImpactTPI tpi={props.tpi ?? 0}></ImpactTPI>
      {/if}
      {#if props.count > 1}
        <BaseBtn onclick={() => props.onRemoveSuggestion(props.selected)}>
          <Icon icon="Close" class="size-4 text-c-light"></Icon>
        </BaseBtn>
      {/if}
    </div>
    {#if props.hidden}
      <AiSuggestionHidden onShowSuggestion={props.onUnhideSuggestion}></AiSuggestionHidden>
    {:else}
      <div class="pl-3 pr-6 font-sans text-sm font-normal text-c-base">
        <!-- eslint-disable-next-line svelte/no-at-html-tags -->
        {@html props.text ?? ''}
      </div>
    {/if}
    <div class="flex justify-end">
      <PaginationNext
        current={props.selected}
        pages={props.count}
        onPageChange={props.onSelectSuggestion}
      ></PaginationNext>
    </div>
  {/if}
</div>
